import React from 'react';
import { Icon, Spin, StatusPill, InvPill, MarginChip,
         Drawer, Modal, Tabs, FG, Pagination } from '../components/ui.jsx';
import { api, fmt, fmtD } from '../api.js';
import { ARCHIVE_STATUSES, SL, STATUS_COLORS, MONTHS, PAGE_SIZE } from '../constants.js';

export const ArchivePage = ({onNav}) => {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [filterStatus, setFilterStatus] = React.useState('');
  const [filterYear, setFilterYear] = React.useState('');
  const [search, setSearch] = React.useState('');
  const [offset, setOffset] = React.useState(0);
  const [sel, setSel] = React.useState(null);
  const limit = PAGE_SIZE;

  const load = () => {
    setLoading(true);
    let qs = `?archived=true&limit=${limit}&offset=${offset}`;
    if (filterStatus) qs += `&status=${filterStatus}`;
    if (filterYear) qs += `&year=${filterYear}`;
    api(`/projects${qs}`).then(d => {
      // Client-side search filter
      let items = d.items || [];
      if (search) {
        const sq = search.toLowerCase();
        items = items.filter(p =>
          (p.title||'').toLowerCase().includes(sq) ||
          (p.code||'').toLowerCase().includes(sq) ||
          (p.client_name||'').toLowerCase().includes(sq)
        );
      }
      setData({...d, items});
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  React.useEffect(() => { load(); }, [offset, filterStatus, filterYear]);
  React.useEffect(() => { setOffset(0); }, [filterStatus, filterYear, search]);

  const openP = async (id) => {
    const p = await api(`/projects/${id}`);
    setSel(p);
  };

  const changeStatus = async (id, newStatus) => {
    await api(`/projects/${id}`, 'PATCH', {status: newStatus});
    load();
    if (sel && sel.id === id) {
      setSel(prev => ({...prev, status: newStatus}));
    }
  };

  // Stats
  const items = data?.items || [];
  const total = data?.total || 0;
  const totalRevenue = items.reduce((s, p) => s + (+(p.revenue||0)), 0);

  const years = [];
  const cy = new Date().getFullYear();
  for (let y = cy; y >= cy - 3; y--) years.push(y);

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Archivio cantieri</div>
          <div className="page-title-sub">{total} cantieri archiviati</div>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:8}}>
          <input className="input" style={{width:200}} placeholder="Cerca..."
            value={search} onChange={e => setSearch(e.target.value)}/>
          <select className="input" style={{width:140}} value={filterStatus}
            onChange={e => setFilterStatus(e.target.value)}>
            <option value="">Tutti gli stati</option>
            {ARCHIVE_STATUSES.map(s => <option key={s} value={s}>{SL[s]}</option>)}
          </select>
          <a href="/api/export/projects?archived=true" download className="btn btn-ghost btn-sm" style={{fontSize:11}}>
            <Icon name="download" size={12} color="var(--n500)"/>CSV
          </a>
          <select className="input" style={{width:100}} value={filterYear}
            onChange={e => setFilterYear(e.target.value)}>
            <option value="">Anno</option>
            {years.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>

      {/* Stats row */}
      <div className="kpi-row" style={{marginBottom:16}}>
        {[
          {icon:'archive',val:total,label:'Totale archiviati',color:'var(--n700)'},
          {icon:'file-check',val:items.filter(p=>p.status==='fatturato').length,label:'Fatturati',color:'#3730A3'},
          {icon:'check-circle',val:items.filter(p=>p.status==='pagato').length,label:'Pagati',color:'#166534'},
          {icon:'trending-up',val:fmt(totalRevenue),label:'Revenue totale',color:'#065F46'},
        ].map(k => (
          <div key={k.label} className="kpi-card">
            <Icon name={k.icon} size={18} color={k.color} style={{marginBottom:8}}/>
            <div className="kpi-val" style={{color:k.color,fontSize:'1.3rem'}}>{k.val}</div>
            <div className="kpi-lbl">{k.label}</div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="card" style={{padding:0}}>
        {loading ? (
          <div className="empty"><Spin/> Caricamento...</div>
        ) : (
          <>
            <table>
              <thead>
                <tr>
                  <th>Codice</th><th>Cantiere</th><th>Date</th>
                  <th>Cliente</th><th>Stato</th>
                  <th style={{textAlign:'right'}}>Revenue</th>
                  <th>Fattura</th><th></th>
                </tr>
              </thead>
              <tbody>
                {items.map(p => (
                  <tr key={p.id} style={{cursor:'pointer'}} onClick={() => openP(p.id)}>
                    <td><span style={{fontWeight:700,color:'var(--blue)',fontSize:12}}>{p.code}</span></td>
                    <td style={{fontWeight:500,fontSize:13,maxWidth:200}}>
                      <div style={{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{p.title}</div>
                    </td>
                    <td style={{fontSize:12,color:'var(--n400)',whiteSpace:'nowrap'}}>{fmtD(p.date_start)}</td>
                    <td style={{fontSize:12,color:'var(--n600)'}}>{p.client_name||'-'}</td>
                    <td><StatusPill val={p.status}/></td>
                    <td style={{textAlign:'right',fontWeight:600,color:'#065F46',fontSize:12}}>
                      {p.revenue>0?fmt(p.revenue):'-'}
                    </td>
                    <td><InvPill val={p.invoice_status}/></td>
                    <td style={{textAlign:'right'}}>
                      {p.status!=='archived' && (
                        <button className="btn btn-ghost btn-sm"
                          style={{padding:'3px 6px',fontSize:10}}
                          onClick={e => {e.stopPropagation(); changeStatus(p.id, 'archived');}}>
                          <Icon name="archive" size={11} color="var(--n400)"/>
                        </button>
                      )}
                      {p.status==='archived' && (
                        <button className="btn btn-ghost btn-sm"
                          style={{padding:'3px 6px',fontSize:10}}
                          onClick={e => {e.stopPropagation(); changeStatus(p.id, 'closed');}}>
                          <Icon name="rotate-ccw" size={11} color="var(--n400)"/>
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
                {!items.length && !loading && (
                  <tr><td colSpan={8} className="empty" style={{padding:30}}>
                    {search ? `Nessun risultato per "${search}"` : 'Nessun cantiere archiviato'}
                  </td></tr>
                )}
              </tbody>
            </table>
            <div style={{padding:'0 16px'}}>
              <Pagination total={total} limit={limit} offset={offset} onChange={setOffset}/>
            </div>
          </>
        )}
      </div>

      {/* Drawer dettaglio */}
      <Drawer open={!!sel} onClose={() => setSel(null)}
        title={sel?.title} subtitle={sel?.code} width={500}
        actions={
          <div style={{display:'flex',gap:6}}>
            <button className="btn btn-ghost btn-sm" onClick={() => {onNav&&onNav('projects',sel?.id); setSel(null);}}>
              <Icon name="external-link" size={12} color="var(--n500)"/>Apri in Cantieri
            </button>
          </div>
        }>
        {sel && (
          <div>
            {/* Status progression */}
            <div style={{marginBottom:16,padding:'12px 14px',background:'var(--n50)',borderRadius:10}}>
              <div style={{fontSize:11,color:'var(--n400)',fontWeight:700,textTransform:'uppercase',
                letterSpacing:'.06em',marginBottom:8}}>Stato cantiere</div>
              <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                {['closed','fatturato','pagato','archived'].map(st => {
                  const active = sel.status === st;
                  const c = STATUS_COLORS[st];
                  return (
                    <button key={st} onClick={() => changeStatus(sel.id, st)}
                      style={{padding:'6px 12px',borderRadius:8,fontSize:12,fontWeight:active?700:500,
                        background:active?c.bg:'var(--n0)',color:active?c.color:'var(--n400)',
                        border:`1.5px solid ${active?c.border:'var(--n200)'}`,
                        cursor:'pointer',transition:'all .15s'}}>
                      {SL[st]}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Info */}
            {[
              ['Codice', sel.code],
              ['Date', `${fmtD(sel.date_start)}${sel.date_end&&sel.date_end!==sel.date_start?' — '+fmtD(sel.date_end):''}`],
              ['Cliente', sel.client_name],
              ['Responsabile', sel.manager_name],
              ['Tipologia', sel.tipologia],
              ['Location', sel.location],
            ].filter(([,v]) => v).map(([k,v]) => (
              <div key={k} style={{display:'flex',padding:'7px 0',borderBottom:'1px solid var(--n100)'}}>
                <span style={{width:100,fontSize:12,color:'var(--n400)',fontWeight:600,flexShrink:0}}>{k}</span>
                <span style={{fontSize:13}}>{v}</span>
              </div>
            ))}

            {sel.revenue>0 && (
              <div style={{marginTop:14,padding:'12px 16px',background:'var(--blue-50)',
                border:'1px solid var(--blue-pale)',borderRadius:8}}>
                <div className="flex-between">
                  <span style={{fontSize:12,color:'var(--n400)'}}>Revenue</span>
                  <span style={{fontSize:18,fontWeight:700,color:'var(--blue)'}}>{fmt(sel.revenue)}</span>
                </div>
              </div>
            )}

            {sel.notes && (
              <div style={{marginTop:12,padding:12,background:'var(--n50)',borderRadius:8,
                fontSize:12,color:'var(--n600)',lineHeight:1.6}}>
                {sel.notes}
              </div>
            )}
          </div>
        )}
      </Drawer>
    </div>
  );
};
